<!-- Asset Service Table View -->

<template>
  <b-container fluid class="p-3">
    <b-row class="p-3" v-if="skeletonloading">
      <b-col>
        <SkeletonTableLoader :columns="headers" :loading="skeletonloading" />
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col>
        <Tableview
          :value="list"
          :paginator="true"
          class="p-datatable-gridlines commonstatusclass"
          :rows="10"
          :rowHover="true"
          filterDisplay="menu"
          responsiveLayout="scroll"
          :columns="headers"
          @row-click=""
          :globalFilterFields="globalFilterFields"
          :filters="filters"
          @ShowRows=""
          :exceldownload="true"
          :filterbtn="true"
          :statusFilterBtn="true"
        >
          <template v-slot:Add>
            <span class="add">
              <AddButton
                :btnname="$t('btn.plusaddnew')"
                class="float-rights my-3"
                @click="OpenSidebar('')"
              />
            </span>
          </template>
          <template v-slot:Status="{ data }">
            <GreenStatus name="Open" v-if="data.Status == 1" />
            <GreyStatus name="In Progress" v-if="data.Status == 2" />
            <BlueStatus name="In Hold" v-if="data.Status == 3" />
            <OrangeStatus name="Cancelled" v-if="data.Status == 4" />
            <RedStatus name="Closed" v-if="data.Status == 5" />
          </template>
          <template v-slot:Priority="{ data }">
            <GreenStatus name="Low" v-if="data.Status == 1" />
            <BlueStatus name="Medium" v-if="data.Status == 2" />
            <RedStatus name="High" v-if="data.Status == 3" />
          </template>
          <template v-slot:action="{ data }">
            <span>
              <Button
                icon="pi pi-ellipsis-v"
                class="p-button-rounded editicon p-button-text"
                @click="toggle($event, data)"
              />
            </span>
          </template>
        </Tableview>
      </b-col>
    </b-row>
  </b-container>
  <Menu ref="menu" id="overlay_menu" :model="actionlist" :popup="true" />
  <AssetServiceRightSidebar
    :trigger="CommonObject.sidebaropen"
    :tableId="CommonObject.Id"
    @closedetailsrightsidebar="CloseSidebar()"
  />
  <EditConfirmation
    :Editmodel="Editmodel"
    @yes="OpenSidebar()"
    @no="Editmodel = false"
    :content="$t('confirmation.editcontent')"
  />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import AssetServiceRightSidebar from "../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/view/AssetService/AssetServiceRightSidebar.vue";
import MaintenanceScheduleMasterServices from "../../../../../Service/AssetManagement/MaintenanceScheduleMasterService";
import AssetMasterService from "../../../../../../../modules/Inventory/Service/AssetManagement/AssetMasterService";
import AssetMaintenanceService from "../../../../../../../modules/Inventory/Service/AssetManagement/AssetMaintenanceService";
import AssetService from "../../../../../Service/AssetManagement/AssetServiceManagementService";
import EditConfirmation from "../../../../../../../components/FormComponents/EditConfirmation.vue";

export default defineComponent({
  components: {
    SkeletonTableLoader,
    Tableview,
    AssetServiceRightSidebar,
    EditConfirmation,
  },

  setup() {
    const { t } = useI18n();
    const skeletonloading = ref(false);
    const router = useRouter();
    const routes = useRoute();
    const tableId = ref();
    const menu = ref();
    const list = ref<any[]>([]);
    const Editmodel = ref(false);
    const ParamValues = ref({
      StoreId: Number(routes.query.Id ?? 0),
      BranchId: Number(routes.query.BranchId ?? 0),
    });

    let CommonObject = ref({
      Id: 0,
      sidebaropen: false,
    });

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let SessionRoleData = localStorage.getItem("RolesData");
    let RolesData;
    if (SessionRoleData !== null) {
      RolesData = JSON.parse(SessionRoleData);
    }
    let isAdmin = usersData.Admin;
    const headers = ref([
      {
        header: t("assetManagement.service.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.service.code"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "boldclass text_overflow2",
      },
      {
        header: t("assetManagement.service.asset"),
        field: "AssetName",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "boldclass text_overflow2",
      },
      {
        header: t("assetManagement.service.maintenancetype"),
        field: "MaintenanceType",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.service.supplier"),
        field: "SupplierName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.service.fromstore"),
        field: "FromStoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.service.expectedreturndate"),
        field: "ExpectedReturnDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.service.priority"),
        field: "Priority",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        slot: "Priority",
        fieldDisplay: "false",
      },
      {
        header: t("assetManagement.service.costestimate"),
        field: "CostEstimate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.service.reason"),
        field: "ReasonName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.service.status"),
        field: "Status",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        slot: "Status",
        fieldDisplay: "false",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        hide: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ]);

    const globalFilterFields = ref(headers.value.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      assetName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      maintenanceType: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      Supplier: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      FromStore: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      ExpectedReturnDate: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      Priority: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      CostEstimate: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      Reason: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      Status: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
    };

    const toggle = (event, data) => {
      CommonObject.value.Id = data.Id;
      menu.value.toggle(event);
    };

    const actionlist = computed(() => [
      {
        items: [
          {
            label: "Edit",
            icon: "pi pi-pencil",
            visible: true,
            command: async () => {
              Editmodel.value = true;
            },
          },
        ],
      },
    ]);
    onMounted(() => {
      IsShow();
    });

    async function IsShow() {
      debugger;
      try {
        let roleId;
        if (isAdmin !== 1) {
          roleId = RolesData.RoleId;
        } else {
          roleId = 0;
        }
        let count = 0;
        skeletonloading.value = true;
        const dataresponse = await AssetService.getdata();
        list.value = dataresponse["result"].map((item) => {
          count = count + 1;
          // Add RowNumber
          item.RowNumber = count;
          return item;
        });
        skeletonloading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function OpenSidebar() {
      Editmodel.value = false;
      CommonObject.value.sidebaropen = true;
    }

    function CloseSidebar() {
      CommonObject.value.sidebaropen = false;
      CommonObject.value.Id = 0;
    }

    return {
      skeletonloading,
      ParamValues,
      t,
      headers,
      globalFilterFields,
      list,
      filters,
      CommonObject,
      CloseSidebar,
      toggle,
      menu,
      actionlist,
      tableId,
      IsShow,
      OpenSidebar,
      Editmodel,
    };
  },
});
</script>

<style scoped>
.btnTab {
  all: unset;
  background-color: #ffffff;
  color: #4361ee;
  border-radius: 5px;
  border: 1px solid #e1e1e1;
  padding: 10px 12px;
}

.btnPosition {
  position: absolute;
  top: 15px;
  left: 20px;
  display: flex;
  z-index: 9;
}

.btnactiveTab {
  background-color: #4361ee;
  color: #ffffff;
}

.action-button {
  width: 100%;
  height: 100%;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  padding: 0.55rem 1rem !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1) !important;
  text-align: left !important;
  font-size: 0.85rem !important;
  background-color: #e7e7e7 !important;
  border-color: #e9e9e9 !important;
  color: #444 !important;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2) !important;
}

.action-button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.action-button i {
  margin-right: 0.5rem !important;
  font-size: 1rem !important;
}
</style>
